var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['status-label', _vm.status]},[_vm._v(" "+_vm._s(_vm.$t(("common." + (_vm.page.toLowerCase()))))+" "+_vm._s(_vm.$t(("common.activation_status." + _vm.status)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }